<i18n>
  {
    "en_US": {
      "title": "Oops... it looks like this is not the event you're looking for!",
      "subtitle": "Why not create a new one?",
      "createEvent": "Create a new event"
    },
    "fr_FR": {
      "title": "Oops... l'événement que vous recherchez a disparu !",
      "subtitle": "Pourquoi ne pas en créer un nouveau ?",
      "createEvent": "Créer un événement"
    }
  }
</i18n>

<template>
  <section class="hero is-medium c-background--image">
    <div class="hero-body">
      <div class="container has-text-centered">
        <h1 class="title is-size-1 has-text-white">
          {{ $t('title') }}
        </h1>
        <h2 class="subtitle is-size-3 has-text-white">
          {{ $t('subtitle') }}
        </h2>
        <router-link to="/" exact class="button is-large is-primary">{{ $t('createEvent') }}</router-link>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'event-missing'
  }
</script>



// WEBPACK FOOTER //
// src/components/EventMissing.vue